"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StockInfo = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  margin: theme.spacing(3, 0, 2)
}));
const EstimatedDelivery = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginLeft: theme.spacing(2)
}));
const InStockFlag = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.success.main,
  fontWeight: 'bold',
  lineHeight: 1.3,
  padding: theme.spacing(1, 2),
  textTransform: 'uppercase',
  background: (0, _mui.alpha)(theme.palette.success.main, 0.1),
  borderRadius: theme.spacing(1)
}));
const OutOfStockFlag = (0, _mui.styled)(InStockFlag)(({
  theme
}) => ({
  color: theme.palette.error.dark,
  background: (0, _mui.alpha)(theme.palette.error.main, 0.1)
}));
const DeliveryDate = (0, _mui.styled)('div')({
  alignItems: 'center',
  display: 'flex',
  marginLeft: 'auto'
});
const ProductWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  flexWrap: 'wrap',
  textAlign: 'left',
  paddingBottom: theme.spacing(1),
  marginBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  '&:last-of-type': {
    padding: 0,
    margin: 0,
    border: 'none'
  }
}));
const ProductDescription = (0, _mui.styled)('div')({
  width: '100%'
});
const StockInfo = ({
  estimatedDelivery,
  isHomeDelivery,
  outOfStockQuantity,
  outOfStockProducts
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const outOfStockItemsCount = (0, _utils.getOutOfStockQuantity)({
    outOfStockQuantity,
    outOfStockProducts
  });
  const stockInfoMessage = (0, _hooks.useInfoMessage)(outOfStockItemsCount);
  const [isTooltipOpen, setIsTooltipOpen] = (0, _react.useState)(false);
  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };
  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };
  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();
    setIsTooltipOpen(prevState => !prevState);
  };
  const oosFlagProps = {
    ...getTestIdProps(_models.TestId.OosFlag),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick
  };
  const getOutOfStockFLag = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(OutOfStockFlag, {
    variant: "overline",
    ...oosFlagProps,
    children: stockInfoMessage
  });
  const getStockInfo = () => {
    if (outOfStockQuantity !== undefined && outOfStockQuantity > 0) {
      return getOutOfStockFLag();
    }
    if (outOfStockProducts && outOfStockProducts.length > 0) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
        enterTouchDelay: 0,
        open: isTooltipOpen,
        title: outOfStockProducts.map(({
          itemCode,
          name,
          quantity
        }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProductWrapper, {
          children: [quantity, " x ", itemCode, /*#__PURE__*/(0, _jsxRuntime.jsx)(ProductDescription, {
            children: name
          })]
        }, itemCode)),
        children: getOutOfStockFLag()
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(InStockFlag, {
      variant: "overline",
      children: stockInfoMessage
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [getStockInfo(), !isHomeDelivery && estimatedDelivery ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(DeliveryDate, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Truck, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(EstimatedDelivery, {
        children: estimatedDelivery
      })]
    }) : null]
  });
};
exports.StockInfo = StockInfo;